var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrailerPlate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13760_19403)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_13760_19403)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.1309,
    height: 8.01518,
    transform: "matrix(-1 0 0 1 22.8154 5.93457)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5538 18.6903C18.3441 18.6903 17.3634 17.7097 17.3634 16.4999C17.3634 15.2902 18.3441 14.3096 19.5538 14.3096C20.7635 14.3096 21.7441 15.2902 21.7441 16.4999C21.7441 17.7097 20.7635 18.6903 19.5538 18.6903Z",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.29814 16.5H12.9824",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2021 14.3096H1.2984",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1729 18.6903C13.9632 18.6903 12.9825 17.7097 12.9825 16.4999C12.9825 15.2902 13.9632 14.3096 15.1729 14.3096C16.3826 14.3096 17.3633 15.2902 17.3633 16.4999C17.3633 17.7097 16.3826 18.6903 15.1729 18.6903Z",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2021 5.54785H1.2984",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.29785 14.3096V16.4999",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.67871 18.6904V16.5",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2021 5.54785V14.3093",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.29785 14.3093V5.54785",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13760_19403"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.25)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_13760_19403"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 14.8235,
    fill: "white",
    transform: "matrix(-1 0 0 1 24.25 4.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrailerPlate);
export default __webpack_public_path__ + "static/media/trailerPlate.a83bb56488ff1ce643f660d83c06f1d9.svg";
export { ForwardRef as ReactComponent };